// Generated by purs version 0.15.16
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
var PushStep3History = /* #__PURE__ */ (function () {
    function PushStep3History() {

    };
    PushStep3History.value = new PushStep3History();
    return PushStep3History;
})();
var ReplaceStep3History = /* #__PURE__ */ (function () {
    function ReplaceStep3History() {

    };
    ReplaceStep3History.value = new ReplaceStep3History();
    return ReplaceStep3History;
})();
var transitionIsCurrent = function (state) {
    return function (generation) {
        if (state.latest instanceof Data_Maybe.Just) {
            return state.latest.value0.generation === generation;
        };
        if (state.latest instanceof Data_Maybe.Nothing) {
            return false;
        };
        throw new Error("Failed pattern match at Steps.Step3.Transition (line 64, column 40 - line 66, column 21): " + [ state.latest.constructor.name ]);
    };
};
var latestTransition = function (v) {
    return v.latest;
};
var finishTransition = function (state) {
    return function (generation) {
        if (state.latest instanceof Data_Maybe.Just && state.latest.value0.generation === generation) {
            return new Data_Tuple.Tuple(true, {
                nextGeneration: state.nextGeneration,
                active: false,
                latest: Data_Maybe.Nothing.value
            });
        };
        return new Data_Tuple.Tuple(false, state);
    };
};
var enqueueTransition = function (state) {
    return function (position) {
        return function (anchor) {
            var historyMode = (function () {
                if (state.latest instanceof Data_Maybe.Just) {
                    return state.latest.value0.historyMode;
                };
                if (state.latest instanceof Data_Maybe.Nothing) {
                    return PushStep3History.value;
                };
                throw new Error("Failed pattern match at Steps.Step3.Transition (line 47, column 23 - line 49, column 40): " + [ state.latest.constructor.name ]);
            })();
            var generation = state.nextGeneration + 1 | 0;
            var pending = {
                generation: generation,
                position: position,
                anchor: anchor,
                historyMode: historyMode
            };
            return new Data_Tuple.Tuple(!state.active, {
                active: true,
                latest: new Data_Maybe.Just(pending),
                nextGeneration: generation
            });
        };
    };
};
var emptyTransitionState = /* #__PURE__ */ (function () {
    return {
        active: false,
        latest: Data_Maybe.Nothing.value,
        nextGeneration: 0
    };
})();
export {
    PushStep3History,
    ReplaceStep3History,
    emptyTransitionState,
    enqueueTransition,
    latestTransition,
    transitionIsCurrent,
    finishTransition
};
//# sourceMappingURL=index.js.map
